import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { routes } from './app.routes';
import { AppInterceptor } from './interceptor/app.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { pendingRequestsInterceptor$ } from 'ng-http-loader';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgIdleModule } from '@ng-idle/core';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { registerLocaleData } from '@angular/common';
import localeHi from '@angular/common/locales/hi';
// import { registerLocaleData } from '@angular/common';
import localeEnIn from '@angular/common/locales/en-IN';


registerLocaleData(localeHi, 'hi-IN');
registerLocaleData(localeEnIn, 'en-IN');

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'disabled',
    })),
    provideHttpClient(withInterceptors([AppInterceptor,ErrorInterceptor,pendingRequestsInterceptor$]),
      withFetch(),
      withInterceptorsFromDi()),
      importProvidersFrom(
        FormsModule ,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        NgIdleModule.forRoot(),
        SelectDropDownModule,
        NgIdleKeepaliveModule.forRoot(), 
      ),
      { provide: LOCALE_ID, useValue: 'hi-IN' }
  ],

};
